'use strict';

/**
 * View for rendering a single set in the select/update set modal
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('modules/collection/modules/set/templates/partials/select-set-sets-list-item.hbs');

var SelectSetSetsListItemView = ItemView.extend({
    wrapItem: false,

    template: template,

    ui: {
        'noChild': '.no-child',
        'hasChild': '.has-child',
        'addChild': '[data-action="add-set"]',
    },

    events: {
        'click': 'onClickItem',
        'click @ui.addChild': 'onAddChild',
    },

    viewData: {
        isRecent: function() {
            return this.getOption('isRecent');
        },
    },

    /**
     * Is triggered, when the item is klicked
     * We will notify the layout view with the details
     */
    onClickItem: function(event) {
        if (this.model.get('restricted') === true) {
            event.preventDefault();

            return;
        }

        if (this.model.hasSubSet()) {
            var level = this.$el.parents('.lane').data('level');
            this.triggerMethod('set:goto', level, this.model);
        } else {
            this.triggerMethod('set:selected', this.model);
        }
    },

    /**
     * Is triggered, when the item is klicked
     * We will notify the layout view with the details
     */
    onAddChild: function() {
        if (App.user.get('canCreateSet') !== true) {
            event.preventDefault();

            return;
        }

        var level = this.$el.parents('.lane').data('level');
        this.triggerMethod('set:add', level, this.model);
    },
});

module.exports = SelectSetSetsListItemView;